export class ClearShiftsLoadingStatus {
    public static readonly type = '[JobsPlacements] Clear shifts loading status';
}
